module.exports = __webpack_public_path__ + "img/gallery_layout6.3d823f78.png";